import { KeenIcon, LazyFormikSelect } from '@/components';
import { forwardRef, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { useLazyOptions, useTaxOptions } from '@/hooks';
import { toast } from 'sonner';
import taxService from '@/services/billing/taxService';
import { InputSanitizers } from '@/utils';
import { PriceInput } from '@/components/form';

const ItemsModal = forwardRef(({
  open,
  onCloseModal,
  handleMode,
  data,
  onSubmit,
  createFieldLoading,
  updateFieldLoading,
  showTaxes = true,
  showDescription = true
}, formikRef) => {
  if (!open) return null;
  console.log(showDescription, showTaxes);

  const isViewMode = handleMode === 'edit';
  const [dataLoading, setDataLoading] = useState(false)
  const [taxesData, setTaxesData] = useState([])
  const loadTaxOptions = useTaxOptions({ defaultPageSize: 20 });

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    // code: Yup.string().required('Code is required'),
    // price: Yup.string().required('Price is required'),
    // taxes: Yup.array()
    // .of(
    //     Yup.string().required('User ID is required')
    // )
    // .min(1, 'At least one tax must be assigned')
    // .required('Taxes is required'),
    // taxes: Yup.array().min(1, 'At least one tax must be selected').required('Required')
  });

  const initialValues = {
    name: data?.name || '',
    code: data?.code || '',
    price: Number(data?.price) > 0 ? data.price : '', // "0.00" would show as $0.00 (OL-184)
    // taxes: data?.taxes?.map(user => user.id) || [],
    // taxes_arr: data?.taxes
    //   ? data.taxes.map(tax => ({
    //     label: tax.name,
    //     value: tax.id,
    //     id: tax.id,
    //   })) : [],
    description: data?.description || '',
  };


  return (
    <div className="modal-wrapper modal-animate-fade">

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={formikRef}
        onSubmit={(values, formikRef) => {
          const payload = {
            ...values,
            // taxes: values.taxes.map(tax => tax.id)
          }
          // console.log('payload', payload)
          // return
          onSubmit(values, formikRef)
        }}
      >

        {({ errors, values, handleChange, handleSubmit, setFieldValue }) => (
          <Form noValidate className="modal-animate-scale scrollable-y-auto bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-6 rounded-lg shadow-lg w-4/5 max-w-xl relative">
            <h3 className="card-title capitalize mb-5">
              {isViewMode ? 'Edit' : 'Create'} Item
            </h3>
            <button
              type="button"
              onClick={onCloseModal}
              className="modal-close-btn"
            >
              <KeenIcon icon="cross" />
            </button>

            <div className='w-full'>
              <label className="form-label mb-1">Name <span className='pl-px text-red-600'>*</span></label>
              <Field name="name" className="input" />
              <ErrorMessage name="name" component="div" className="text-red-500 text-xs mt-1" />
            </div>

            <div className='w-full my-3'>
              <label className="form-label mb-1">Code </label>
              <Field name="code" className="input" />
              <ErrorMessage name="code" component="div" className="text-red-500 text-xs mt-1" />
            </div>

            <div className='w-full'>
              <label className="form-label mb-1">Price </label>
              <PriceInput name='price' prefix="$" />
            </div>

            {/* {showTaxes && (
              <div className='w-full my-3'>
                <label className="form-label mb-1">Taxes </label>
                <LazyFormikSelect
                  name='taxes'
                  placeholder="Select Taxes"
                  loadOptions={loadTaxOptions}
                  pageSize={20}
                  isMulti={true}
                  preloadedOption={initialValues.taxes_arr.length > 0 ? initialValues.taxes_arr : []}
                />
                <ErrorMessage name="taxes" component="div" className="text-red-500 text-xs mt-1" />
              </div>
            )} */}

            {showDescription && (
              <div className='w-full my-3'>
                <label className="form-label mb-1">Description</label>
                <Field name="description" as="textarea" rows="4" cols="50" className="min-h-[120px] input py-3 leading-[1.4em]" />
                <ErrorMessage name="description" component="div" className="text-red-500 text-xs mt-1" />
              </div>
            )}

            <button type="submit" disabled={createFieldLoading || updateFieldLoading} className="btn btn-primary justify-center w-full mt-2">
              {isViewMode ?
                updateFieldLoading ? 'Please Wait...' : 'Update Item'
                : createFieldLoading ? 'Please wait...' : 'Create Item'}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
});

export { ItemsModal };
